// extracted by css-extract-rspack-plugin
export default {"codeTag":"rxxfKzTBOPM0x6Y_","inlineBlock":"UGKf9mFP4Y8Ja94L"};